import { createContext, useContext } from "react"

export interface ProductPositionTableLoadingRowPayload {
  hideQuantity?: boolean
  showClarificationRequestColumn?: boolean
  showSelectionCheckbox?: boolean
  columnPreset?: "default" | "selection"
}

export const ProductPositionTableLoadingRowPayloadContext =
  createContext<ProductPositionTableLoadingRowPayload>({})

export const useProductPositionTableLoadingRowPayload = () =>
  useContext(ProductPositionTableLoadingRowPayloadContext)
